import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

// Sales Incentives on the POS (store comes from the POS token). Display only.
export const salesIncentivesApi = createApi({
  reducerPath: 'salesIncentivesApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({

    // Badge product list. Sends If-None-Match with the last ETag; 304 means "keep what you have".
    // Returns { status, etag, productIds } (productIds null on 304).
    fetchIncentiveProductIds: builder.mutation({
      query: (etag) => ({
        url: '/sales_incentives/product_ids',
        method: 'GET',
        headers: etag ? { 'If-None-Match': etag } : {},
        cache: 'no-store',
        validateStatus: (response) => response.status === 200 || response.status === 304,
        responseHandler: async (response) => ({
          status: response.status,
          etag: response.headers.get('ETag'),
          productIds: response.status === 304 ? null : ((await response.json())?.data?.product_ids ?? []),
        }),
      }),
    }),

    // Live plans at this store with ranked participants (no cost or achieved values). Fetched only while open.
    getIncentiveLeaderboard: builder.query({
      query: () => '/sales_incentives/leaderboard',
      transformResponse: (res) => res?.data?.plans ?? [],
      keepUnusedDataFor: 0,
    }),

  }),
});

export const {
  useFetchIncentiveProductIdsMutation,
  useGetIncentiveLeaderboardQuery,
} = salesIncentivesApi;
